import { readFromLocalStorage } from '@/lib/local-storage/local-storage';
import type { SessionValues } from './types';
import { DEFAULT_SESSION_VALUES, SESSION_KEY } from './constants';

export function getSessionValues() {
  if (typeof window === 'undefined') {
    return DEFAULT_SESSION_VALUES as SessionValues;
  }
  return readFromLocalStorage<SessionValues>({
    key: SESSION_KEY,
    defaultValue: DEFAULT_SESSION_VALUES,
  });
}
